import React, { useState } from 'react'
import intl from 'react-intl-universal'
import {
  MobileMenuContainer,
  ListWrap,
  ListItem,
  ListItemLink,
  ListItemBlock,
  Mask,
  ProductsLS,
  ProductsWrap,
  ProductsLeft,
  ProductsRight,
  ProductsLink,
  Expanddiv,
  ResourcesLS,
  ResourcesCenter,
  ResourcesRight,
  ResourcesLink,
  RightLS,
  DropdownWrapRe,
  ResourcesLeft,
  TitleText,
  LanguageLeft,
  LanguageRight,
} from './en-atoms'
import { LocaleService, LOCALES } from '../../services'
import SubMenuArrow from '../svg/enHome/SubMenuArrow'
import MoreProducts1 from '@raysync/common/components/svg/enHome/more_products1'
import MoreProducts2 from '@raysync/common/components/svg/enHome/more_products2'
import MoreProducts3 from '@raysync/common/components/svg/enHome/more_products3'
import Icon1 from '../svg/enHome/icon_resources1'
import Icon2 from '../svg/enHome/icon_resources2'
import Icon3 from '../svg/enHome/icon_resources3'
import Icon4 from '../svg/enHome/icon_resources4'
import Icon5 from '../svg/enHome/icon_resources5'
import Icon6 from '../svg/enHome/icon_resources6'
import Icon7 from '../svg/enHome/mobile_resources7'
import Icon8 from '../svg/enHome/icon_resources8'
import Icon9 from '../svg/enHome/icon_resources9'
import Icon10 from '../svg/enHome/icon_resources10'
import Icon11 from '../svg/enHome/icon_resources11'
import IconLearnMore from '../svg/enHome/icon_learnmore'
import HerderEnIcon from '../svg/enHome/herder-en'
import ChackIcon from '../svg/enHome/chack'

const currentPackageName = process.env.GATSBY_PACKAGE_NAME
class MobileMenu extends React.Component {
  listRef = React.createRef()
  getLanguageFromPath = pathname => {
    const match = pathname.match(/\/(ja|en|es|de|fr|pt)\//)
    return match ? match[1].toUpperCase() : 'EN'
  }
  constructor(props) {
    super(props)
    this.state = {
      language: this.getLanguageFromPath(window.location.pathname),
      expands: [],
      itemHeights: [],
    }
  }

  componentDidMount() {
    this.calculateHeights()
    this.updateBodyStyle()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.list !== this.props.list) {
      this.calculateHeights()
    }
    this.updateBodyStyle()
  }

  calculateHeights() {
    const liList = this.listRef.current.children
    const heights = Array.from(liList).map(li => li.scrollHeight)
    this.setState({ itemHeights: heights })
  }

  updateBodyStyle() {
    const body = document.querySelector('body')
    if (this.props.isExpand) {
      body.style.overflow = 'hidden'
      body.style.height = '1px'
    } else {
      body.style.overflow = 'auto'
      body.style.height = 'initial'
    }
  }

  toggleExpands = index => {
    this.setState(prevState => {
      const newExpands = [...prevState.expands]
      newExpands[index] = !newExpands[index]
      return { expands: newExpands }
    })
  }

  handleActive = ({ children, hasMulti }, pathname) => {
    if (hasMulti) {
      return children.some(c => c.items.some(i => i.link === pathname))
    }
    return children.some(i => i.link === pathname)
  }

  render() {
    const { isExpand, pathname = [], closeExpand, showTopNotice } = this.props
    const { expands, itemHeights, language } = this.state

    const languageList = [
      {
        text: 'English',
        language: LOCALES.EN,
      },
      {
        text: 'España',
        language: LOCALES.ES,
      },
      {
        text: 'Deutsch',
        language: LOCALES.DE,
      },
      {
        text: 'Français',
        language: LOCALES.FR,
      },
      {
        text: 'Türkçe',
        language: LOCALES.TR,
      },
      {
        text: '日本語',
        language: LOCALES.JA,
      },
      {
        text: 'Português',
        language: LOCALES.PT,
      },
    ]
    const currentLanguage = LocaleService.getLocale()

    const currentLanguageText = languageList.find(item => item.language === currentLanguage)?.text

    let navigationList = [
      {
        text: intl.get('app.header.products'),
        children: [
          {
            link: '/enterprise/',
            text: intl.get('enterprise.link'),
            desc: intl.get('enterprise.desc'),
            icon: 'IconProducts1',
          },
          { link: '/smb/', text: intl.get('app.smb'), desc: intl.get('app.desc'), icon: 'IconProducts2' },
          {
            link: '/raysync-cloud/',
            text: intl.get('cloud.link'),
            desc: intl.get('cloud.desc'),
            icon: 'IconProducts3',
          },
        ],
      },
      {
        link: '/pricing/',
        text: intl.get('app.header.pricing'),
      },
      {
        link: '/casestudies/',
        text: intl.get('app.header.example'),
      },
      {
        text: intl.get('app.header.resources'),
        children: [
          {
            link: '/about-us/',
            text: intl.get('app.header.company.about1'),
            desc: intl.get('app.header.company.about1.desc'),
            icon: 'icon1',
          },
          {
            link: '/support/document/index/',
            text: intl.get('support.help-center'),
            desc: intl.get('support.help-center.desc'),
            icon: 'icon2',
          },
          {
            link: '/support/document/faq/Installation-issues/',
            text: intl.get('app.header.resources.faq'),
            desc: intl.get('app.header.resources.faq.desc'),
            icon: 'icon3',
          },
          {
            link: '/news/',
            text: intl.get('app.footer.entry2'),
            desc: intl.get('app.footer.entry2.desc'),
            icon: 'icon4',
          },
        ],
      },
      {
        text: <HerderEnIcon />,
        containsEN: true,
        children: languageList,
      },
    ]
    let Tools = [
      {
        link: '/partners/',
        text: intl.get('app.header.company.partners'),
        desc: intl.get('app.header.company.partners.desc'),
        icon: 'icon5',
      },
      {
        link: '/calculator/',
        text: intl.get('app.footer.calculator'),
        desc: intl.get('app.footer.calculator.desc'),
        icon: 'icon6',
      },
    ]
    let AlternativesList = [
      {
        text: 'Aspera',
        link: '/alternatives/aspera-alternative/',
        icon: 'icon7',
      },
      {
        text: 'Signiant Media Shuttle',
        link: '/alternatives/media-shuttle-alternative/',
        icon: 'icon8',
      },
      {
        text: 'Resilio Sync',
        link: '/alternatives/resilio-sync-alternative/',
        icon: 'icon9',
      },
      {
        text: 'MASV',
        link: '/alternatives/masv-alternative/',
        icon: 'icon10',
      },
      {
        text: 'FileCatalyst',
        link: '/alternatives/filecatalyst-alternative/',
        icon: 'icon11',
      },
    ]
    return (
      <MobileMenuContainer showTopNotice={showTopNotice}>
        <ListWrap ref={this.listRef} isExpand={isExpand}>
          {navigationList.map((l, index) => (
            <ListItem key={l.text} maxHeight={itemHeights[index]} isExpand={expands[index]}>
              {l.children ? (
                <ListItemBlock
                  isActive={this.handleActive(l, pathname)}
                  showarrow={!!l.children}
                  isExpand={expands[index]}
                  onClick={() => {
                    this.toggleExpands(index)
                  }}
                >
                  {l.text}
                  {'  '}
                  {l.containsEN && <span>{currentLanguageText}</span>}
                  <SubMenuArrow isExpand={expands[index]} />
                </ListItemBlock>
              ) : (
                <ListItemLink to={l.link} isActive={pathname === l.link}>
                  {l.text}
                </ListItemLink>
              )}

              {l.text === intl.get('app.header.products') && (
                <Expanddiv>
                  {l.children.map((k, j) =>
                    l.text === intl.get('app.header.products') ? (
                      <ProductsLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={j + 100}>
                        <ProductsWrap>
                          <ProductsLeft>
                            {k.icon === 'IconProducts1' && <MoreProducts1 />}
                            {k.icon === 'IconProducts2' && <MoreProducts2 />}
                            {k.icon === 'IconProducts3' && <MoreProducts3 />}
                          </ProductsLeft>
                          <ProductsRight>
                            <ProductsLink
                              style={{ fontSize: 14 }}
                              to={k.link.startsWith('/') ? k.link : `/${k.link}`}
                              isInternal={currentPackageName === 'main'}
                              isActive={new RegExp(`${k.link}$`).test(pathname)}
                            >
                              <TitleText>
                                {k.text} <IconLearnMore />
                              </TitleText>
                              <p>{k.desc}</p>
                            </ProductsLink>
                          </ProductsRight>
                        </ProductsWrap>
                      </ProductsLS>
                    ) : null,
                  )}
                </Expanddiv>
              )}
              {l.text === intl.get('app.header.resources') ? (
                <DropdownWrapRe>
                  <ResourcesLeft>
                    <p>{intl.get('app.header.resources.title1')}</p>
                    {l.children.map((k, j) => (
                      <ResourcesLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={j + 100}>
                        <ProductsWrap>
                          <ProductsLeft>
                            {k.icon === 'icon1' && <Icon1 />}
                            {k.icon === 'icon2' && <Icon2 />}
                            {k.icon === 'icon3' && <Icon3 />}
                            {k.icon === 'icon4' && <Icon4 />}
                          </ProductsLeft>
                          <ProductsRight>
                            <ResourcesLink
                              style={{ fontSize: 14 }}
                              to={k.link}
                              isActive={new RegExp(`${k.link}$`).test(pathname)}
                            >
                              <TitleText>
                                {k.text} <IconLearnMore />
                              </TitleText>
                              <p>{k.desc}</p>
                            </ResourcesLink>
                          </ProductsRight>
                        </ProductsWrap>
                      </ResourcesLS>
                    ))}
                  </ResourcesLeft>

                  <ResourcesCenter>
                    <p>{intl.get('app.header.resources.title2')}</p>
                    {Tools.map((a, b) => (
                      <ResourcesLS isActive={new RegExp(`${a.link}$`).test(pathname)} key={b + 100}>
                        <ProductsWrap>
                          <ProductsLeft>
                            {a.icon === 'icon5' && <Icon5 />}
                            {a.icon === 'icon6' && <Icon6 />}
                          </ProductsLeft>
                          <ProductsRight>
                            <ResourcesLink
                              style={{ fontSize: 14 }}
                              to={a.link}
                              isActive={new RegExp(`${a.link}$`).test(pathname)}
                            >
                              <TitleText>
                                {a.text} <IconLearnMore />
                              </TitleText>
                              <p>{a.desc}</p>
                            </ResourcesLink>
                          </ProductsRight>
                        </ProductsWrap>
                      </ResourcesLS>
                    ))}
                  </ResourcesCenter>

                  <ResourcesRight>
                    <p>{intl.get('app.header.resources.title3')}</p>
                    {AlternativesList.map((c, d) => (
                      <RightLS isActive={new RegExp(`${c.link}$`).test(pathname)} key={d + 100}>
                        <ProductsLeft>
                          {c.icon === 'icon7' && <Icon7 />}
                          {c.icon === 'icon8' && <Icon8 />}
                          {c.icon === 'icon9' && <Icon9 />}
                          {c.icon === 'icon10' && <Icon10 />}
                          {c.icon === 'icon11' && <Icon11 />}
                        </ProductsLeft>
                        <ProductsRight>
                          <ResourcesLink
                            style={{ fontSize: 14 }}
                            to={c.link}
                            isActive={new RegExp(`${c.link}$`).test(pathname)}
                          >
                            <TitleText>
                              {c.text} <IconLearnMore />
                            </TitleText>
                          </ResourcesLink>
                        </ProductsRight>
                      </RightLS>
                    ))}
                  </ResourcesRight>
                </DropdownWrapRe>
              ) : null}
              {l.containsEN && (
                <Expanddiv>
                  {l.children.map((k, j) => (
                    <ProductsWrap>
                      <LanguageLeft>{currentLanguage === k.language && <ChackIcon />}</LanguageLeft>
                      <LanguageRight>
                        <ProductsLink
                          style={{ fontSize: 14 }}
                          onClick={() => {
                            LocaleService.changeLocale(k.language)
                          }}
                          isInternal={currentPackageName === 'main'}
                          isActive={currentLanguage === k.language}
                        >
                          <p>{k.text}</p>
                        </ProductsLink>
                      </LanguageRight>
                    </ProductsWrap>
                  ))}
                </Expanddiv>
              )}
            </ListItem>
          ))}
        </ListWrap>
        <Mask isExpand={isExpand} onClick={closeExpand} />
      </MobileMenuContainer>
    )
  }
}

export default MobileMenu
